import React, { useState, useEffect } from "react";
import "./Form3.scss";
import { FiArrowRight } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form3 = (props) => {
  const [sex, setSex] = useState("");

  const handleChange = (e, value) => {
    setSex(value)
  }

  const disabledBtn = () => {
    if (!sex)
      return true;
    return false;
  };

  const handleSubmit = async() => {
    await props.signup({
      userId: props.userData.signupData.userId,
      sex,
    });
    props.clicking();
  };
  
  return (
    <div className="Form3 w-100">
      <div className="h1">I identify as ...</div>
      <div className="input-wrapper">
        <div className="radio">
          <input
            type="radio"
            id="radio-1"
            name="gender"
            className="form-control"
            value={sex}
            onChange={(e) => handleChange(e, "FEMALE")}
          />
          <label className="option" htmlFor="radio-1">
            FEMALE
          </label>
        </div>
        <div className="radio">
          <input
            type="radio"
            id="radio-2"
            name="gender"
            className="form-control"
            value={sex}
            onChange={(e) => handleChange(e, "MALE")}
          />
          <label className="option" htmlFor="radio-2">
            MALE
          </label>
        </div>
        <div className="radio">
          <input
            type="radio"
            id="radio-3"
            name="gender"
            className="form-control"
            value={sex}
            onChange={(e) => handleChange(e, "OTHER")}
          />
          <label className="option" htmlFor="radio-3">
            OTHER
          </label>
        </div>
      </div>
      <div className="note text-muted text-left">
        I'm creating an account on behalf of my business. Gender is not relevant
        to my profile.
      </div>
      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={()=> handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth,
});

export default connect(mapStateToProps, {
  signup
})(Form3);
